import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { StatusBadge } from "@/components/shared/StatusBadge";
import { APP_STAGES, ADMIN_STAGES } from "@/lib/constants";

export default function AdminApplications() {
  const [applications, setApplications] = useState([]);
  const [view, setView] = useState("board");
  const navigate = useNavigate();

  useEffect(() => { api.get("/admin/applications").then((r) => setApplications(r.data)).catch(() => {}); }, []);

  const stages = ADMIN_STAGES;

  return (
    <div>
      <div className="flex items-center justify-between">
        <div>
          <p className="eyebrow">Pipeline</p>
          <h1 className="mt-3 font-serif text-3xl tracking-tight">Applications</h1>
        </div>
        <div className="flex gap-2">
          {["board", "list"].map((v) => (
            <button key={v} onClick={() => setView(v)} data-testid={`app-view-${v}`} className={`rounded-full border px-4 py-1.5 font-mono text-[10px] uppercase tracking-widest ${view === v ? "border-gold bg-gold text-[#0A0D14]" : "border-white/10 text-[#94A3B8]"}`}>{v}</button>
          ))}
        </div>
      </div>

      {view === "board" ? (
        <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {stages.map((stage) => {
            const items = applications.filter((a) => a.status === stage);
            return (
              <div key={stage} className="rounded-lg border border-white/5 bg-[#121722] p-3">
                <div className="mb-3 flex items-center justify-between">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-[#94A3B8]">{stage}</span>
                  <span className="font-mono text-[10px] text-gold">{items.length}</span>
                </div>
                <div className="space-y-2">
                  {items.map((a) => (
                    <button key={a.id} onClick={() => navigate(`/admin/applications/${a.id}`)} data-testid={`board-card-${a.id}`} className="w-full rounded-md border border-white/5 bg-[#0A0D14] p-3 text-left transition-all hover:border-gold/30">
                      <p className="font-sans text-sm text-white">{a.candidate_name}</p>
                      <p className="mt-1 font-sans text-xs text-[#94A3B8]">{a.job_title}</p>
                      <p className="mt-1 font-mono text-[9px] uppercase tracking-widest text-[#94A3B8]">{a.application_path}</p>
                    </button>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="mt-8 overflow-hidden rounded-lg border border-white/5">
          <table className="w-full text-left">
            <thead className="bg-[#18202E]">
              <tr className="font-mono text-[10px] uppercase tracking-widest text-[#94A3B8]">
                <th className="px-5 py-3">Application</th><th className="px-5 py-3">Candidate</th><th className="px-5 py-3">Position</th><th className="px-5 py-3">Type</th><th className="px-5 py-3">Status</th><th className="px-5 py-3">Documents</th>
              </tr>
            </thead>
            <tbody>
              {applications.map((a) => (
                <tr key={a.id} onClick={() => navigate(`/admin/applications/${a.id}`)} data-testid={`app-list-row-${a.id}`} className="cursor-pointer border-t border-white/5 hover:bg-white/5">
                  <td className="px-5 py-4 font-mono text-xs text-gold">{a.reference}</td>
                  <td className="px-5 py-4 font-sans text-sm">{a.candidate_name}</td>
                  <td className="px-5 py-4 font-sans text-sm">{a.job_title}</td>
                  <td className="px-5 py-4 font-sans text-xs text-[#94A3B8]">{a.applicant_type?.includes("Foreign") ? "Foreign" : "Local"}</td>
                  <td className="px-5 py-4"><StatusBadge status={a.status} /></td>
                  <td className="px-5 py-4 font-mono text-xs text-[#94A3B8]">{a.documents_uploaded || 0}/{a.documents_required || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
